export const EVALUATION_CRITERIA = [
  { key: 'attitude', label: 'Attitude', description: 'Sportsmanship and positive mindset' },
  { key: 'effort', label: 'Effort', description: 'Physical and mental effort put into training' },
  { key: 'engagement', label: 'Engagement', description: 'Focus and participation in drills' },
  { key: 'physical', label: 'Physical', description: 'Physical conditioning and movement' },
  { key: 'technical', label: 'Technical', description: 'Stroke mechanics and shot execution' },
  { key: 'tactical', label: 'Tactical', description: 'Court awareness and shot selection' },
] as const;

export type EvaluationCriterionKey = typeof EVALUATION_CRITERIA[number]['key'];
